import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.pipe';
import { SearchFormReactivePipe } from './search-form-reactive.pipe';
import { MatThreePipe } from './mat-three.pipe';
import { MyFilterPipe } from './search-array.pipe';
import { TruncatePipePipe } from './truncate-pipe.pipe';



@NgModule({
  declarations: [SearchPipe, SearchFormReactivePipe, MyFilterPipe, TruncatePipePipe],
  imports: [
    CommonModule
  ],
  exports: [
    SearchPipe,
    SearchFormReactivePipe,
    MyFilterPipe,
    TruncatePipePipe
  ]
})
export class PipeModule { }
